/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Outcomeformsentatplaceholder4Inputs */

const en_outcomeformsentatplaceholder4 = /** @type {(inputs: Outcomeformsentatplaceholder4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a date (or leave blank if not sent yet)`)
};

const pt_outcomeformsentatplaceholder4 = /** @type {(inputs: Outcomeformsentatplaceholder4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha a data (ou deixe em branco se ainda não enviou)`)
};

/**
* | output |
* | --- |
* | "Pick a date (or leave blank if not sent yet)" |
*
* @param {Outcomeformsentatplaceholder4Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const outcomeformsentatplaceholder4 = /** @type {((inputs?: Outcomeformsentatplaceholder4Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Outcomeformsentatplaceholder4Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_outcomeformsentatplaceholder4(inputs)
	return pt_outcomeformsentatplaceholder4(inputs)
});
export { outcomeformsentatplaceholder4 as "outcomeFormSentAtPlaceholder" }